//#region directives/focusgroup_directive/focusgroup_constants.js
var e = ":is(button, [href], input, select, textarea, [tabindex]):not([data-dt-focusgroup-skip])", t = Object.freeze({
	selector: "[role=\"menuitem\"], [role=\"menuitemcheckbox\"], [role=\"menuitemradio\"]",
	skipDisabled: !0
}), n = Object.freeze({
	axis: "both",
	loop: !0,
	memory: !0,
	selector: null,
	skipDisabled: null
}), r = Object.freeze({
	tablist: {
		selector: "[role=\"tab\"]",
		skipDisabled: !1
	},
	radiogroup: {
		selector: "[role=\"radio\"]",
		skipDisabled: !0
	},
	listbox: {
		selector: "[role=\"option\"]",
		skipDisabled: !0
	},
	menu: t,
	menubar: t,
	toolbar: {
		selector: e,
		skipDisabled: !0
	}
}), i = Object.freeze({
	horizontal: {
		key: "axis",
		value: "horizontal"
	},
	vertical: {
		key: "axis",
		value: "vertical"
	},
	both: {
		key: "axis",
		value: "both"
	},
	loop: {
		key: "loop",
		value: !0
	},
	noloop: {
		key: "loop",
		value: !1
	},
	memory: {
		key: "memory",
		value: !0
	},
	nomemory: {
		key: "memory",
		value: !1
	},
	skipdisabled: {
		key: "skipDisabled",
		value: !0
	},
	noskipdisabled: {
		key: "skipDisabled",
		value: !1
	}
}), a = [
	"axis",
	"loop",
	"memory",
	"selector",
	"skipDisabled"
];
//#endregion
export { a as CONFIG_KEYS, e as FOCUSABLE_SELECTOR, n as FOCUSGROUP_DEFAULTS, r as ROLE_DEFAULTS_MAP, i as TOKEN_MAP };

//# sourceMappingURL=focusgroup-constants.js.map